import * as React from "react";
import { omitBy } from "lodash-es";
import { casesActions } from "configs";
import {
  useParams,
  FormWatcherCallback,
  resolveNumber,
  resolveString,
  useDispatch,
  useCurrentCase
} from "duck";
import { useUpdatePatientMiscellaneousMutation } from "requests";
import { FormValues } from "./types";

export const useUpdate = (id: number) => {
  const { id: caseId } = useParams();
  const dispatch = useDispatch();
  const [update] = useUpdatePatientMiscellaneousMutation({
    ignoreResults: true
  });
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return React.useCallback<FormWatcherCallback<FormValues>>(
    values => {
      const variables = omitBy(
        {
          catheterSize: values.catheterSize,
          catheterLocation: values.catheterLocation,
          fluidType: values.fluidType,
          bloodPressureMonitoring: values.bloodPressureMonitoring,
          fluidRate: resolveNumber(values.fluidRate),
          fluidRateValue: resolveNumber(values.fluidRateValue),
          qualityOfSedation: values.qualityOfSedation,
          anesthesiaSystem: values.anesthesiaSystem,
          bagSize: resolveNumber(values.bagSize),
          oxygenFlowRate: resolveNumber(values.oxygenFlowRate),
          intubated:
            values.intubated === null
              ? null
              : values.intubated === "true"
              ? true
              : values.intubated === "false"
              ? false
              : undefined,
          endotrachealTubeSize: resolveString(values.endotrachealTubeSize)
        },
        value => value === undefined
      );

      if (shouldSync) {
        dispatch(
          casesActions.updateMiscellaneous({ data: variables, _id: caseId })
        );
        return update({ variables: { input: { _id: id, ...variables } } });
      }

      dispatch(
        casesActions.updateMiscellaneous({ data: variables, _id: caseId })
      );
    },
    [id, update]
  );
};
